export default function _escapeRegex(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}
